import { Box } from "@material-ui/core";
import { CustomIcon } from "..";
import closeButtonStyles from "./CloseButton.styles";
import { ReactComponent as Exit } from "../../../assets/icons/exit-icon.svg";

interface CustomProps {
  onClick: Function;
  customClasses?: string;
}

const CloseButton = (props: CustomProps) => {
  const classes = closeButtonStyles();
  const appliedClass = props.customClasses
    ? props.customClasses
    : classes.closeBtn;

  const getCloseButton = () => {
    return (
      <Box className={appliedClass} onClick={() => props.onClick()}>
        <CustomIcon icon={<Exit height="24px" width="24px" />} />
      </Box>
    );
  };

  return getCloseButton();
};

export default CloseButton;
